import {Controller} from "stimulus";

// Shows how many characters a text field holds as it is edited. Counts
// characters the way Ruby's String#length does, and the saved post keeps each
// line break as a single character, so the count matches the one shown once
// the text is saved.
export default class extends Controller {
    static targets = ["input", "output"];

    connect() {
        this.update();
    }

    update() {
        const length = Array.from(this.inputTarget.value).length;
        this.outputTarget.textContent = `${length} ${length === 1 ? "character" : "characters"}`;
    }
}
